import { controls,grouped } from "../controls";
const clients = {
label: "Clients",
pageLabel: "Clients",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
bulk:{columns:["client_code","client_display","bank_id","client_uri","welcome_text","background_url","logo_url","icon_url","client_active"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Client Portals",uid: "client_portals",fastpath:"client_portals"},
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "client_code",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "client_display",width:"col-sm-4",maxlength:200}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "client_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "client_code",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "client_display",isRequired:true,width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Bank",star:false}),
...controls.oc({ tab: "general", c: "Bank", placeHolder: "Bank Code", name: "bank_code",fastpath: "banks",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "bank_display"}),
...controls.displayText({ tab: "general", label: "Client Uri",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "client_uri",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "general", label: "Welcome Text",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "welcome_text",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "general", label: "Background Url",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "background_url",width:"col-sm-4",maxlength:236}),
...controls.displayText({ tab: "general", label: "Logo Url",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "logo_url",width:"col-sm-4",maxlength:236}),
...controls.displayText({ tab: "general", label: "Icon Url",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "icon_url",width:"col-sm-4",maxlength:236}),
...controls.checkBox({ tab: "general", label: "Active",default:true, name: "client_active" }),
...controls.displayText({ tab: "client_portals", label: "Portal",star:true}),
...controls.oc({ tab: "client_portals", c: "Portal", placeHolder: "Portal", name: "portal_code",fastpath: "portals",clearData: ['portal_scheme_code'],hidden:false}),
...controls.showData({ tab: "client_portals", displaytype: "capital", data: "portal_display"}),
...controls.displayText({ tab: "client_portals", label: "Portal Scheme",star:false}),
...controls.oc({ tab: "client_portals", c: "PortalScheme", placeHolder: "Portal Scheme Code", name: "portal_scheme_code",fastpath: "portal_schemes",autoopen:true,sendToServer: { sendData: [{ varname: 'portal.portal_uid', value: 'portal_uid' }] } ,hidden:false}),
...controls.showData({ tab: "client_portals", displaytype: "capital", data: "portal_scheme_display"}),
...controls.displayText({ tab: "client_portals", label: "Description",star:false}),
...controls.text({ tab: "client_portals",  placeHolder: "", name: "description",width:"col-sm-4",maxlength:500}),
...controls.checkBox({ tab: "client_portals", label: "Active",default:true, name: "client_portal_active" }),
...controls.checkBox({ tab: "client_portals", label: "Allow Otp",default:false, name: "allow_otp" }),
...controls.checkBox({ tab: "client_portals", label: "Allow Userpass",default:false, name: "allow_userpass" }),
...controls.checkBox({ tab: "client_portals", label: "Allow Qr",default:false, name: "allow_qr" }),

...controls.displayText({ tab:"client_portals" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"client_portals" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"client_portals",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "client_portals",
  requiredField: ["portal_code","portal_display","portal_uid","portal_scheme_code","portal_scheme_display","portal_scheme_uid","description","client_portal_active","allow_otp","allow_userpass","allow_qr",],
required:["portal_code","portal_display","portal_uid",],
}, width: "col-sm-2"
}),
...controls.button({
tab:"client_portals",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "client_portals",
  requiredField: ["portal_code","portal_display","portal_uid","portal_scheme_code","portal_scheme_display","portal_scheme_uid","description","client_portal_active","allow_otp","allow_userpass","allow_qr",]
}, width: "col-sm-2"
}),
{
  tab:"client_portals",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Portal Code", field: "portal_code"},
    { label: "Portal", field: "portal_display"},
    { label: "Portal Scheme Code", field: "portal_scheme_code"},
    { label: "Portal Scheme ", field: "portal_scheme_display"},
    { label: "Description", field: "description"},
    { label: "Client Portal Active", field: "client_portal_active", displaytype: "tick"},
    { label: "Allow Otp", field: "allow_otp", displaytype: "tick"},
    { label: "Allow Userpass", field: "allow_userpass", displaytype: "tick"},
    { label: "Allow Qr", field: "allow_qr", displaytype: "tick"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "client_portals"
},
]
,history:{
perPage: 10,
reportHeader: "Clients",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Client Code",accessor: "client_code",},
{Header: "Client",accessor: "client_display",},
{Header: "Client Active",accessor: "client_active",type:'tick'},
]}};
export default clients;